<div [formGroup]="signatureFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid"
     class="with-loading-overlay">

    <mat-checkbox formControlName="sign">
        {{conditionCheckboxLabel}}
    </mat-checkbox>

    <ng-container *ngIf="signatureFormGroup.get('sign').value === true">

        <div fxFlex="100" fxLayout="column" class="mt-24">
            <strong>
                {{ 'workflows.formWidgets.signature.howShouldSign' | translate }}
            </strong>

            <mat-radio-group class="radio-group"
                             [(ngModel)]="signatureType"
                             [ngModelOptions]="{standalone: true}"
                             (ngModelChange)="signatureTypeChanged($event)">
                <mat-radio-button [value]="SignatureTypes.Text">{{ 'workflows.formWidgets.signature.modeText' | translate }}</mat-radio-button>
                <mat-radio-button [value]="SignatureTypes.Sign">{{ 'workflows.formWidgets.signature.modeSign' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>

        <ng-container *ngIf="signatureType === SignatureTypes.Text">
            <div fxFlex="100">
                <p>
                    {{ 'workflows.formWidgets.signature.textIntro' | translate }}
                </p>
            </div>

            <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                <mat-label>{{ 'workflows.formWidgets.signature.signatureFieldLabel' | translate }}</mat-label>
                <input matInput data-test="FI-Name" type="text" formControlName="signatureText"
                       autocomplete="new-password">
                <mat-error>{{signatureFormGroup.get('signatureText').errors | firstErrorMessage}}</mat-error>
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="signatureType === SignatureTypes.Sign">
            <div fxFlex="100">
                {{ 'workflows.formWidgets.signature.padLabel' | translate }}
                <signature-pad [options]="signaturePadOptions"
                               (onBeginEvent)="drawStart()"
                               (onEndEvent)="drawComplete()"></signature-pad>
                <ng-container
                    *ngIf="signatureFormGroup.get('signature').invalid && signatureFormGroup.get('signature').touched">
                    <div>
                        <mat-error>{{signatureFormGroup.get('signature').errors | firstErrorMessage}}</mat-error>
                    </div>
                </ng-container>
            </div>

            <div class="pt-8">
                <button type="button"
                        mat-stroked-button
                        (click)="clearSignature()"
                        [disabled]="!isSigned">
                    <mat-icon>undo</mat-icon>
                    {{ 'workflows.formWidgets.signature.clearPad' | translate }}
                </button>
            </div>

        </ng-container>
    </ng-container>
</div>
